<template>
  <div class="w-full rounded-lg">
    <t-form
      ref="form"
      class="postal-form-step border-0 flex-col p-6 overflow-hidden"
      @submit="onSubmit"
      @submit.prevent
    >
      <h6 class="input-header mb-2">Vul hier uw postcode in</h6>

      <div class="postal-form-step__form">
        <PostalSeparateInputs
          class="postal-form-step__separate-inputs mb-8"
          :error-messages="errorMessages"
          @result="onResult"
          @change="onChange"
        />

        <FormStepSubmitButton
          id="submitPostal"
          class="postal-form-step__btn border-0 font-bold w-44 px-10 py-3 rounded-lg"
          :text="btnText"
        />
      </div>
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import PostalSeparateInputs from 'chimera/all/components/form/fields/postal/PostalSeparateInputs.nl'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import Vue from 'vue'
import NextStep from '~/pages/offertes-aanvragen/start.vue'

export default {
  name: 'PostalFormStepPd8337',

  components: {
    FormErrorMessages,
    PostalSeparateInputs,
  },

  extends: AbstractFormStep,

  props: {
    btnText: {
      type: String,
      default: 'Ga verder',
    },
  },

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      // Temporary goal for experiment PD-8337
      Vue.prototype.$absmartly.track('pd-8337-enter-form-hero')

      this.routeTo(NextStep)
    },
  },
}
</script>

<style lang="scss" scoped>
.postal-form-step {
  @apply text-black;

  .formstep-btn {
    background: linear-gradient(167deg, #ee3b13 47.92%, #c1062b 126.29%);
  }
}
</style>
